import VueRouter from 'vue-router'
import Vue from 'vue'

import Login from '@/pages/Login'
import Dashboards from '@/pages/Dashboards'
import Dashboard from '@/pages/Dashboard'
import DashboardEdit from '@/pages/DashboardEdit'

// import Reports from '@/pages/Reports'
import Servers from '@/pages/Servers'
import Server from '@/pages/Server'
import SystemSettings from '@/pages/SystemSettings'
import UserSettings from '@/pages/UserSettings'
import UISettings from '@/pages/UISettings'
import UiElementEdit from '@/pages/UiElementEdit'

import Models from '@/pages/Models'
import Sources from '@/pages/Sources'
import Source from '@/pages/Source'
import Outputs from '@/pages/Outputs'
import Output from '@/pages/Output'
import Pipelines from '@/pages/Pipelines'
import Pipeline from '@/pages/Pipeline'

import Mergers from '@/pages/Mergers'
import Merge from '@/pages/Merge'

import Lists from '@/pages/Lists'
import List from '@/pages/List'
import ListItems from '@/pages/ListItems'
import VideoPage from '@/pages/VideoPage'

import auth from '@/middleware/auth.js'

import title from '@/assets/localisations/router_title.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/video',
    name: 'video',
    query: {
      video_data: undefined
    },
    meta: {
      layout: 'videolayout'
    },
    component: VideoPage
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'login'
    },
    component: Login
  },
  {
    path: '/',
    name: 'dashboards',
    component: Dashboards,
    meta: {
      title: title.dashboards
    }
  },
  {
    path: '/dashboards/:dashboard_id',
    name: 'dashboard',
    component: Dashboard,
    props: true,
    meta: {
      hideHeader: true,
      editableTitle: true,
      title() {
        return {
          title: '',
          name: this.$route.params.name
        }
      },
      breadcrumbs() {
        return [
          {
            title: title.dashboards[this.$i18n.locale].title,
            path: '/dashboards'
          },
          {
            title: title.add_dashboard[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/dashboards/:dashboard_id/edit',
    name: 'edit_dashboard',
    component: DashboardEdit,
    props: true,
    meta: {
      editableTitle: true,
      title() {
        return {
          title: '',
          name: this.$route.params.name
        }
      },
      breadcrumbs() {
        return [
          {
            title: title.dashboards[this.$i18n.locale].title,
            path: '/dashboards'
          },
          {
            dashboard_name_title: true,
            title: this.$route.params.dashboard_id,
            path: `/dashboards/${this.$route.params.dashboard_id}`
          },
          {
            title: title.edit_dashboard[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/dashboard/add_dashboard',
    name: 'add_dashboard',
    component: DashboardEdit,
    props: true,
    meta: {
      editableTitle: true,
      title: title.dashboard,
      breadcrumbs() {
        return [
          {
            title: title.dashboards[this.$i18n.locale].title,
            path: '/dashboards'
          },
          {
            title: title.add_dashboard[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },

  {
    path: '/servers',
    name: 'servers',
    component: Servers,
    meta: {
      title: title.servers
    }
  },
  {
    path: '/servers/add_server',
    name: 'add_server',
    component: Server,
    props: true,
    query: {
      duplicate: undefined
    },
    meta: {
      editableTitle: true,
      title() {
        return {
          title: '',
          name: this.$route.params.name
        }
      },
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            title: title.add_server[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id',
    name: 'server',
    component: Server,
    props: true,
    meta: {
      editableTitle: true,
      title() {
        return {
          title: '',
          name: this.$route.params.name
        }
      },
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            title: title.add_server[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/models',
    name: 'models',
    component: Models,
    props: true,
    meta: {
      title: title.models,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.models[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/pipelines',
    name: 'pipelines',
    component: Pipelines,
    props: true,
    meta: {
      title: title.pipelines,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.pipelines[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/pipelines/add_pipeline',
    name: 'add_pipeline',
    component: Pipeline,
    query: {
      duplicate: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.pipeline,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.pipelines[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/pipelines`
          },
          {
            title: title.add_pipeline[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/pipelines/:pipeline_id/',
    name: 'pipeline',
    component: Pipeline,
    props: true,
    meta: {
      editableTitle: true,
      title: title.pipeline,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.pipelines[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/pipelines`
          },
          {
            title: title.add_pipeline[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },

  {
    path: '/servers/:server_id/mergers',
    name: 'mergers',
    component: Mergers,
    props: true,
    meta: {
      title: title.mergers,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: 'Merge configs',
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/mergers/:merger_id/',
    name: 'merge',
    component: Merge,
    props: true,
    meta: {
      editableTitle: true,
      title: title.merge,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.pipelines[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/mergers`
          },
          {
            title: title.add_pipeline[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/mergers/add_merge',
    name: 'add_merge',
    component: Merge,
    query: {
      type: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.merge,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.sources[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/mergers`
          },
          {
            title: title.add_source[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/sources',
    name: 'sources',
    component: Sources,
    props: true,
    meta: {
      title: title.sources,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.sources[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/sources/add_source',
    name: 'add_source',
    component: Source,
    query: {
      type: undefined,
      duplicate: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.source,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.sources[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/sources`
          },
          {
            title: title.add_source[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/sources/:source_id/',
    name: 'source',
    component: Source,
    props: true,
    meta: {
      editableTitle: true,
      title: title.source,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.sources[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/sources`
          },
          {
            title: title.add_source[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/outputs',
    name: 'outputs',
    component: Outputs,
    props: true,
    meta: {
      title: title.outputs,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.outputs[this.$i18n.locale].title,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/outputs/add_output',
    name: 'add_output',
    component: Output,
    query: {
      type: undefined,
      duplicate: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.output,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.outputs[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/outputs`
          },
          {
            title: title.add_output[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/servers/:server_id/outputs/:output_id/',
    name: 'output',
    component: Output,
    props: true,
    meta: {
      editableTitle: true,
      title: title.outputs,
      breadcrumbs() {
        return [
          {
            title: title.servers[this.$i18n.locale].title,
            path: '/servers'
          },
          {
            server_name_title: true,
            title: this.$route.params.server_id,
            path: `/servers/${this.$route.params.server_id}`
          },
          {
            title: title.outputs[this.$i18n.locale].title,
            path: `/servers/${this.$route.params.server_id}/outputs`
          },
          {
            title: title.add_output[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/user_settings',
    name: 'user_settings',
    component: UserSettings,
    meta: {
      title: title.user_settings
    }
  },
  {
    path: '/system_settings',
    name: 'system_settings',
    component: SystemSettings,
    meta: {
      title: title.system_settings
    }
  },
  {
    path: '/ui_settings',
    name: 'ui_settings',
    component: UISettings,
    meta: {
      title: title.ui_settings
    }
  },
  {
    path: '/ui_settings/add_ui_element',
    name: 'add_ui_element',
    component: UiElementEdit,
    query: {
      dashboard_id: undefined,
      type: undefined,
      duplicate: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.ui_element,
      breadcrumbs() {
        return [
          {
            title: title.ui_settings[this.$i18n.locale].title,
            path: '/ui_settings'
          },
          {
            title: title.add_ui_element[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/ui_settings/:ui_element_id/edit',
    name: 'edit_ui_element',
    component: UiElementEdit,
    props: true,
    query: {
      dashboard_id: undefined
    },
    meta: {
      editableTitle: true,
      title() {
        return {
          title: '',
          name: this.$route.params.name
        }
      },
      breadcrumbs() {
        const links = []
        if (this.$route.query.dashboard_id) {
          links.push({
            title: title.dashboards[this.$i18n.locale].title,
            path: '/dashboards'
          })
        }
        links.push(
          {
            dashboard_name_title: this.$route.query.dashboard_id ? true : false,
            title: this.$route.query.dashboard_id
              ? this.$route.query.dashboard_id
              : title.ui_settings[this.$i18n.locale].title,
            path: this.$route.query.dashboard_id ? `/dashboards/${this.$route.query.dashboard_id}/edit` : '/ui_settings'
          },
          {
            ui_element_name_title: true,
            title: this.$route.params.ui_element_id,
            path: this.$route.fullPath
          }
        )
        return links
      }
    }
  },
  {
    path: '/lists',
    name: 'lists',
    component: Lists,
    meta: {
      title: title.lists
    }
  },
  {
    path: '/lists/list/:list_id',
    name: 'list',
    component: List,
    props: true,
    meta: {
      editableTitle: true,
      title: title.lists,
      breadcrumbs() {
        return [
          {
            title: title.lists[this.$i18n.locale].title,
            path: '/lists'
          },
          {
            title: title.list[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/lists/list/:list_id/items',
    name: 'list_items',
    component: ListItems,
    props: true,
    meta: {
      editableTitle: false,
      title: title.list_items,
      breadcrumbs() {
        return [
          {
            title: title.lists[this.$i18n.locale].title,
            path: '/lists'
          },
          {
            list_name_title: true,
            title: this.$route.params.list_id,
            path: `/lists/list/${this.$route.params.list_id}`
          },
          {
            title: title.list_items[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  },
  {
    path: '/lists/add_list',
    name: 'add_list',
    component: List,
    query: {
      type: undefined
    },
    props: true,
    meta: {
      editableTitle: true,
      title: title.lists,
      breadcrumbs() {
        return [
          {
            title: title.lists[this.$i18n.locale].title,
            path: '/lists'
          },
          {
            title: title.add_list[this.$i18n.locale].title,
            page_title: true,
            path: this.$route.fullPath
          }
        ]
      }
    }
  }
]

const router = new VueRouter({
  linkExactActiveClass: 'is-active',
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  auth({
    to,
    from,
    next,
    router
  })
})
export default router
